<template>
  <div class="constainer-fluid">
    <div class="row">
      <div class="col-md-12"></div>
    </div>
    <div class="row">
      <!-- Feed -->
      <div class="col-md-12">
        <div class="row bordered" v-if="false">
          <div class="col-md-12 pt-3 pt-2 main-post">
            <div class="row">
              <div class="col-10 pl-md-0 d-flex align-items-center">
                <textarea
                  name=""
                  id=""
                  rows="4"
                  class="w-100 border-0 textarea"
                  placeholder="What's on your mind, Complustech?"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-12 post-add-ons py-2">
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-11">
                <a class="text-decoration-none text-dak px-md-4">
                  <span><i class="pi pi-video mr-3"></i></span>
                  <span class="text-dark">Video</span>
                </a>
                <a class="text-decoration-none text-dak px-md-4">
                  <span><i class="pi pi-images mr-3"></i></span>
                  <span class="text-dark">Photo/Video</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row px-1 mt-3" v-if="isConnected">
          <div
            v-for="(post, index) in feed"
            :key="index"
            class="border rounded-xl p-4 mb-4 shadow-sm bg-white"
          >
            <!-- HEADER -->
            <div class="d-flex align-items-center mb-3">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram Logo"
                class="rounded-circle"
                width="45"
                height="45"
              />
              <div class="ml-3">
                <h6 class="mb-0 font-weight-bold text-dark">Instagram Page</h6>
                <small class="text-muted">{{
                  formatDate(post.timestamp)
                }}</small>
              </div>
            </div>

            <!-- CAPTION -->
            <p class="text-dark mb-3" v-if="post.caption">
              {{
                expandedPosts.has(post.id)
                  ? post.caption
                  : truncatedCaption(post.caption)
              }}
              <span
                v-if="post.caption.length > 150"
                class="primary--text font-weight-600 cursor-pointer ml-1"
                @click="toggleCaption(post.id)"
              >
                {{ expandedPosts.has(post.id) ? "See less" : "See more" }}
              </span>
            </p>

            <!-- MEDIA -->
            <div v-if="post.mediaUrl" class="mb-3 text-center">
              <img
                v-if="
                  post.mediaType === 'IMAGE' ||
                  post.mediaType === 'CAROUSEL_ALBUM'
                "
                :src="post.mediaUrl"
                alt="Instagram Post"
                class="w-100 rounded-xl"
                style="max-height: 500px"
              />
              <video
                v-else-if="post.mediaType === 'VIDEO'"
                :src="post.mediaUrl"
                class="w-100 rounded-xl"
                height="240"
                controls
              ></video>
            </div>

            <!-- ACTIONS -->
            <div class="d-flex justify-content-between border-top pt-3">
              <a class="text-decoration-none text-dark c-pointer">
                <i class="pi pi-heart mr-2"></i>Like
              </a>
              <a
                :href="post.permalink"
                target="_blank"
                class="text-decoration-none text-primary"
              >
                View on Instagram
              </a>
            </div>
          </div>

          <div
            v-if="feed.length === 0 && loadingPost === false"
            class="text-center text-muted mt-5"
          >
            No posts available.
          </div>

          <div
            class="col-md-12 d-flex justify-content-center mt-4"
            v-if="loadingPost"
          >
            <div style="width: 3rem; height: 3rem" role="status">
              <el-icon :size="38" class="is-loading">
                <Loading />
              </el-icon>
            </div>
          </div>

          <div v-if="false">
            <div
              class="row bordered my-5"
              v-for="(post, index) in feed"
              :key="index"
            >
              <div class="col-md-12 py-3">
                <!-- User details -->
                <div class="row">
                  <div class="col-2 d-md-flex justify-content-center">
                    <div class="img-holder bg-secondary">
                      <img
                        :src="post.posterDetails.posterImageUrl"
                        alt="User Image"
                        style="height: 40px; width: 100%"
                      />
                    </div>
                  </div>
                  <div class="col-10 pl-md-0">
                    <p
                      class="mb-0 font-weight-600 mb-n2 d-flex justify-content-between"
                    >
                      <span>{{ post.posterDetails.posterName }}</span>
                      <span><i class="pi pi-ellipsis-h c-pointer"></i></span>
                    </p>
                    <small class="mb-0">{{ formatDate(post.date) }}</small>
                  </div>
                </div>

                <!-- Post message -->
                <div class="row">
                  <div class="col-md-12 pt-3">
                    <h5 class="font-weight-600 mb-0">
                      {{ post.postCategoryName }}
                    </h5>
                    <p class="mb-0 text-justify">
                      <span
                        v-if="
                          post.showFullMessage ||
                          post.content.length < previewLenth
                        "
                        >{{ post.content }}</span
                      >
                      <span v-else>{{ post.briefMessage }}...</span>
                      <span
                        v-if="post.content.length > previewLenth"
                        class="font-weight-700 primary-text c-pointer ml-3"
                        @click="
                          () => (post.showFullMessage = !post.showFullMessage)
                        "
                        >{{
                          post.showFullMessage ? "See less" : "See more"
                        }}</span
                      >
                    </p>
                  </div>
                </div>

                <!-- Post media -->
                <div class="row">
                  <div class="col-md-12">
                    <img
                      v-if="post.type === 'Picture'"
                      :src="post.mediaUrl"
                      class="w-100"
                      alt=""
                    />
                    <video
                      v-if="post.type === 'Video'"
                      style="width: 100%"
                      height="240"
                      controls
                    >
                      <source :src="post.mediaUrl" />
                      <!-- <source src="movie.mp4" type="video/mp4"> -->
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>

                <!-- Post Actions -->
                <div class="row my-3">
                  <div class="col-md-12">
                    <a
                      class="text-decoration-none c-pointer post-action-link px-3 px-md-4"
                    >
                      <span><i class="pi pi-thumbs-up mr-2"></i></span>
                      <span>Like</span>
                      <span class="ml-2">{{ post.likeCount }}</span>
                    </a>
                    <a
                      class="text-decoration-none c-pointer post-action-link px-3 px-md-4"
                    >
                      <span><i class="pi pi-comment mr-2"></i></span>
                      <span>Comment</span>
                      <span class="ml-2">{{
                        post.comments ? post.comments.length : 0
                      }}</span>
                    </a>
                    <a
                      class="text-decoration-none c-pointer post-action-link px-3 px-md-4"
                    >
                      <span><i class="pi pi-share-alt mr-2"></i></span>
                      <span>Share</span>
                    </a>
                  </div>
                </div>

                <div
                  class="row my-3"
                  v-for="(comment, indx) in post.comments"
                  :key="indx"
                >
                  <div>
                    <div class="pt-3 pb-4 pl-3 pr-5 small-border-radius">
                      <h6 class="mb-0 font-weight-600">
                        {{ comment.commenterName }}
                      </h6>
                      <p class="mb-0 small-text">
                        {{ comment.commentMessage.trim() }}
                      </p>
                    </div>
                    <div class="px-2">
                      <p class="mb-0">
                        <small>{{
                          formatDate(comment.commentDate).toLowerCase()
                        }}</small>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row my-2 justify-content-center">
                  <div class="col-md-11 mt-3 d-flex align-items-center">
                    <form class="w-100">
                      <p class="mb-0 w-100">
                        <textarea
                          rows="1"
                          class="textarea mt-0 medium-border-radius px-2 py-2 comment-field"
                          @keyup="postComment($event, post.postId, index)"
                          v-model="comment.message"
                          placeholder="Comment..."
                        ></textarea>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-md-12 mt-4 px-0 border shadow-lg rounded d-flex justify-content-center align-items-center"
          style="height: 450px"
          v-if="!isConnected && !loaded"
        >
          <div class="feeds-card">
            <div
              v-if="!isConnected"
              class="connect-box d-flex justify-content-center flex-column align-items-center"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                width="40"
              />
              <p class="text-center text-black font-weight-600 mt-2">
                Instagram page management <br />
                is not set up yet
              </p>

              <el-button
                round
                :color="primarycolor"
                class="px-5 text-white"
                size="large"
                @click="getfacebookLoginUrl"
              >
                Connect
              </el-button>
            </div>
          </div>
        </div>

        <!-- SKELETON LOADER -->
        <div class="row mt-3" v-if="loaded">
          <div class="col-md-12">
            <div class="row my-4">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-2 my-2">
                    <Skeleton
                      shape="circle"
                      style="width: 100%; height: 70px"
                      class="p-mr-2 small-border-radius"
                    ></Skeleton>
                  </div>
                  <div class="col-10 my-2">
                    <Skeleton
                      style="width: 100%; height: 70px"
                      class="small-border-radius"
                    ></Skeleton>
                  </div>
                </div>
              </div>
              <div class="col-md-12 my-2">
                <Skeleton
                  style="width: 100%; height: 200px"
                  class="p-mb-2 small-border-radius"
                ></Skeleton>
              </div>
              <div class="col-md-12 d-flex">
                <Skeleton
                  width="4rem"
                  class="mr-2 small-border-radius"
                  height="2rem"
                ></Skeleton>
                <Skeleton
                  width="4rem"
                  height="2rem"
                  class="mr-2 small-border-radius"
                ></Skeleton>
              </div>
            </div>

            <div class="row my-4">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-2 my-2">
                    <Skeleton
                      shape="circle"
                      style="width: 100%; height: 70px"
                      class="p-mr-2 small-border-radius"
                    ></Skeleton>
                  </div>
                  <div class="col-10 my-2">
                    <Skeleton style="width: 100%; height: 70px"></Skeleton>
                  </div>
                </div>
              </div>
              <div class="col-md-12 my-2">
                <Skeleton
                  style="width: 100%; height: 200px"
                  class="p-mb-2"
                ></Skeleton>
              </div>
              <div class="col-md-12 d-flex">
                <Skeleton
                  width="4rem"
                  class="mr-2 small-border-radius"
                  height="2rem"
                ></Skeleton>
                <Skeleton
                  width="4rem"
                  height="2rem"
                  class="mr-2 small-border-radius"
                ></Skeleton>
              </div>
            </div>

            <div class="row my-4">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-2 my-2">
                    <Skeleton
                      shape="circle"
                      style="width: 100%; height: 70px"
                      class="p-mr-2 small-border-radius"
                    ></Skeleton>
                  </div>
                  <div class="col-10 my-2">
                    <Skeleton
                      style="width: 100%; height: 70px"
                      class="small-border-radius"
                    ></Skeleton>
                  </div>
                </div>
              </div>
              <div class="col-md-12 my-2">
                <Skeleton
                  style="width: 100%; height: 200px"
                  class="p-mb-2 small-border-radius"
                ></Skeleton>
              </div>
              <div class="col-md-12 d-flex">
                <Skeleton
                  width="4rem"
                  class="mr-2 small-border-radius"
                  height="2rem"
                ></Skeleton>
                <Skeleton
                  width="4rem"
                  height="2rem"
                  class="mr-2 small-border-radius"
                ></Skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="displaySocialIDialog"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
      style="border-radius: 20px"
    >
      <h3 class="mb-4 text-center text-black">Setup Facebook Integration</h3>
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <div class="row">
            <div class="col-md-12 mb-3">
              <label class="fw-500 s-14 text-black">Facebook App ID</label>
              <el-input
                type="text"
                placeholder="Enter Facebook App ID"
                v-model="facebookAppId"
              />
            </div>

            <div class="col-md-12 mb-3">
              <label class="fw-500 s-14 text-black">Facebook App Secret</label>
              <el-input
                type="text"
                placeholder="Enter Facebook App Secret"
                v-model="facebookAppSecret"
              />
            </div>

            <div class="col-md-12 mt-3 text-center">
              <el-button
                class="text-white px-5 py-4"
                :color="primarycolor"
                round
                :loading="loading"
                @click="saveFacebookCredentials"
              >
                Save & Continue
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import Skeleton from "primevue/skeleton";
import social_service from "../../../../services/social/social_service";
import membershipService from "../../../../services/membership/membershipservice";
import dateFormatter from "../../../../services/dates/dateformatter";
import { useRouter } from "vue-router";
import deviceBreakpoint from "../../../../mixins/deviceBreakpoint";
import axios from "@/gateway/backendapi";
import { ElNotification } from "element-plus";

const feed = ref([]);
const tenantId = ref("");
const primarycolor = inject("primarycolor");
const facebookLoginUrl = ref(null);
const displaySocialIDialog = ref(false);
const facebookAppId = ref("");
const facebookAppSecret = ref("");
const loading = ref(false);
const loadingPost = ref(false);
const expandedPosts = ref(new Set());
const { lgAndUp, xlAndUp, mdAndUp } = deviceBreakpoint();
const previewLenth = 300;
membershipService
  .getSignedInUser()
  .then((res) => {
    tenantId.value = res.tenantId;
    // ❌ remove direct call to getFeed here
    getSocialMediaConnect(); // ✅ let this decide
    getFeed(tenantId.value);
  })
  .catch((err) => console.log(err));

const loaded = ref(true);

const isConnected = ref(false);
const router = useRouter();
// ✅ Toggle "See more" / "See less"
const toggleCaption = (id) => {
  if (expandedPosts.value.has(id)) {
    expandedPosts.value.delete(id);
  } else {
    expandedPosts.value.add(id);
  }
};

// ✅ Truncate caption
const truncatedCaption = (text, limit = 150) => {
  if (!text) return "";
  return text.length <= limit ? text : text.substring(0, limit) + "...";
};

const getfacebookLoginUrl = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get(`/api/MetaBusiness/login`);
    console.log(data, "Facebook login URL");

    if (!data) {
      displaySocialIDialog.value = true;
    } else {
      facebookLoginUrl.value = data;
      openFacebookPopup(data);
    }
  } catch (error) {
    console.error("Failed to get Facebook login URL:", error);
    displaySocialIDialog.value = true;
  } finally {
    loading.value = false;
  }
};

const saveFacebookCredentials = async () => {
  if (!facebookAppId.value || !facebookAppSecret.value) {
    return ElNotification.error(
      "Please enter both Facebook App ID and Secret Key."
    );
  }

  try {
    loading.value = true;

    const { data } = await axios.post(
      `/api/SocialMediaConnectPlatformSettings`,
      {
        appId: facebookAppId.value,
        appSecretKey: facebookAppSecret.value,
      }
    );

    console.log("Credentials saved:", data);
    ElNotification.success("Facebook credentials saved successfully.");
    displaySocialIDialog.value = false;

    // Fetch login URL again after saving credentials
    await getfacebookLoginUrl();
  } catch (error) {
    ElNotification.error("Failed to save credentials:" || error);
  } finally {
    loading.value = false;
  }
};

const getSocialMediaConnect = async () => {
  try {
    const { data } = await axios.get(`/api/SocialMediaConnectPlatformSettings`);
    console.log(data, "Social Media Settings");

    if (
      data &&
      data.instagramId !== null &&
      data.instagramId !== "" &&
      data.pageAccessToken !== null &&
      data.pageAccessToken !== ""
    ) {
      // ✅ Connected
      isConnected.value = true;
      getFeed(tenantId.value);
    } else {
      // ❌ Not connected
      isConnected.value = false;
      // feed.value = [];
    }
  } catch (error) {
    console.error("Error fetching social media settings:", error);
    isConnected.value = false;
    feed.value = []; // also trigger the connect box
  }
};

const getInstagramPosts = async () => {
  loadingPost.value = true;
  try {
    const { data } = await axios.get(`/api/MetaBusiness/instagram/posts`);

    if (Array.isArray(data) && data.length > 0) {
      feed.value = data;
      isConnected.value = true;
      loadingPost.value = false;
    } else {
      isConnected.value = false;
    }
  } catch (error) {
    isConnected.value = false;
    loadingPost.value = false;
  } finally {
    loadingPost.value = false;
  }
};

getInstagramPosts();

const openFacebookPopup = (url) => {
  const popupWidth = 600;
  const popupHeight = 700;
  const left = (window.screen.width - popupWidth) / 2;
  const top = (window.screen.height - popupHeight) / 2;

  // Construct features string correctly
  const features =
    `width=${popupWidth},height=${popupHeight},top=${top},left=${left},` +
    `toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`;

  document.body.classList.add("dim-background");

  // ✅ Use only 3 arguments: url, window name, features
  const popup = window.open(url, "FacebookLoginPopup", features);

  if (!popup) {
    alert("Popup blocked. Please allow popups for this site.");
    document.body.classList.remove("dim-background");
    return;
  }

  popup.focus();

  const popupTimer = setInterval(async () => {
    if (popup.closed) {
      clearInterval(popupTimer);
      document.body.classList.remove("dim-background");
      return; // Stop further execution
    }

    try {
      const { data } = await axios.get(
        `/api/SocialMediaConnectPlatformSettings`
      );

      if (data) {
        facebookAuth.value = data;
        fBAuth.value = data;

        const hasUserAccessToken =
          data.userAccessToken && data.userAccessToken.trim() !== "";

        if (hasUserAccessToken) {
          // ✅ Connected successfully
          isConnected.value = true;

          clearInterval(popupTimer); // 🛑 Stop further polling
          document.body.classList.remove("dim-background");

          // 👉 Redirect to connected feed page
          router.push("/tenant/social/feed/connectmetta");
        } else {
          // ❌ Incomplete connection
          isConnected.value = false;
          ElNotification.error("Failed to connect your Social Media Page");

          clearInterval(popupTimer); // 🛑 Stop further polling
          document.body.classList.remove("dim-background");
        }
      } else {
        ElNotification.error("Failed to fetch connection details");

        clearInterval(popupTimer); // 🛑 Stop further polling
        document.body.classList.remove("dim-background");
      }
    } catch (error) {
      ElNotification.error("Failed to verify your Social Media connection");

      clearInterval(popupTimer); // 🛑 Stop further polling
      document.body.classList.remove("dim-background");
    }
  }, 800);
};
const getFeed = async (tenantId) => {
  try {
    const response = await social_service.getFeed(tenantId);
    // feed.value = [];
    // feed.value = response.map((i) => {
    //   i.showFullMessage = false;
    //   i.briefMessage = i.content.slice(0, previewLenth);
    //   return i;
    // });
    console.log(response, "feeds");

    loaded.value = false;
  } catch (error) {
    console.log(error);
    loaded.value = false;
  }
};

const comment = ref({});
const postComment = async (e, postId, index) => {
  if (!comment.value.message) return false;
  if (e.keyCode == 13) {
    e.preventDefault();
    try {
      const response = await social_service.postComment({
        postId: postId,
        commentMessage: comment.value.message,
        commenterName: "Church Admin",
      });
      feed.value[index].comments.push(response);
      console.log(feed.value);
      comment.value.message = "";
    } catch (error) {
      console.log(error);
    }
  }
};

const formatDate = (date) => {
  return dateFormatter.monthDayTime(date);
};
</script>

<style scoped>
.blue-bg {
  height: 500px;
  position: absolute;
  background: #0f529f;
  width: 100%;
}

.bg-blue {
  background: #0f529f;
}
.dim-background::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}

.blue-bg:before {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 70%;
  content: "";
  background-color: red;
}

.img-holder {
  border: 1px solid;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  align-items: center;
  display: flex;
  background: white !important;
}

.textarea {
  outline: none;
  margin-top: 10px;
  background: transparent;
}

.post-add-ons {
  background: #f5f6f7;
  border-radius: 0 0 10px 10px;
}

/* .main-post {
            background: #fbfbfb;
        } */

.bordered {
  border: 0.20000000298023224px solid #e9eef0;
  border-radius: 15px;
  background: #fff;
}

.post-action-link {
  color: #4b5257cc;
}

.small-border-radius {
  border-radius: 8px;
  background: #f1f1f1;
}
.medium-border-radius {
  border-radius: 15px;
  border: 1px solid #a2a2a2;
}

.comment-field {
  width: calc(100% - 60px);
}

.all-platforms {
  background: #136acd;
}

.facebook {
  background: #0f529f;
}

.twitter {
  background: #1a91da;
}

.instagram {
  background: transparent
    linear-gradient(81deg, #e90263 0%, #fd0604 49%, #ff5d00 100%) 0% 0%
    no-repeat padding-box;
}

.whatsapp {
  background: transparent linear-gradient(256deg, #48c658 0%, #2ab540 100%) 0%
    0% no-repeat padding-box;
}

.mobile {
  background: #e87109 0% 0% no-repeat padding-box;
}

@media screen and (min-width: 768px) {
  .b-right {
    border-right: 0.20000000298023224px solid #e9eef0;
  }
}
</style>
